import { NodeData } from './NodeData';
import { BlockType } from './../compiler/factory/BlockType';
import { Node } from 'beautiful-react-diagrams/@types/DiagramSchema';
import { NodeCoordinates } from 'beautiful-react-diagrams/@types/DiagramSchema';
import { ElementType, ReactNode } from 'react';
import { OutputNode } from './OutputNode';

/**
 * A code block WhileNode
 */
export class WhileNode extends OutputNode {
    constructor(content: ReactNode,
        coordinates: NodeCoordinates,
        constInputs: any[],
        data: NodeData,
        render: (props: Omit<Node<any>, 'coordinates'>) => ElementType | ReactNode) {
        //todo replace with custom renderer
        super(content, coordinates, 1, BlockType.WHILE, constInputs, data, render);
    }
}